/**
 * Returns a number (all grouping characters removed) from a currency string.
 * For example, "100,234,123.12" returns 100234123.12.
 *
 * Returns 0 if the currency string cannot be converted to a number.
 */
export const getNumberFromCurrencyString = (value, locale) => {
  // Discover the locale's grouping and decimal symbols.
  const testNumber = Intl.NumberFormat(locale, {
    style: 'decimal'
  }).formatToParts(1000.01);
  const groupingSymbol = testNumber.find(part => part.type === 'group')?.value || '';
  const decimalSymbol = testNumber.find(part => part.type === 'decimal')?.value || '';

  /**
   * To ensure Number() accurately converts the string to a number (no NaN).
   * - Remove commas
   * - For locales that use a comma as the decimal separator
   */
  let cleanedValue = value.replaceAll(groupingSymbol, '');
  if (decimalSymbol === ',') {
    cleanedValue = cleanedValue.replace(',', '.');
  }
  const number = Number(cleanedValue);
  if (Number.isNaN(number)) return 0;
  return number;
};